import i18next from "i18next";
import MomentTimeZone from "moment-timezone";
import { Trans } from "react-i18next";
var jwt = require("jsonwebtoken");
import axios from "axios";
import { apiEndPointFromNode } from "client.config";

const timezone = Intl.DateTimeFormat().resolvedOptions().timeZone;

export const getCurrentTime = () => {
    return MomentTimeZone().tz(timezone).format("YYYY-MM-DDTHH:mm:ss");
};

export const checkAndChangeContent = (name, location) => {
  if (name === location) {
      name = "United States";
  } else if (name === "If") {
      //5377 - For German browser language when "Indien" is translated to english we are getting response as "If".
      name = "India";
  }
  return name;
}

export const getBrowserLanguage = () => {
    var currentBrowserLang =
        window.navigator.userLanguage || window.navigator.language;

    var browserLang = currentBrowserLang.split("-")[0];
    if (browserLang === null) {
      browserLang = "en"
    }
    return browserLang;
};

//5278 add support for browser language
export const translateContent = async (content, target) => {
    var browserLang = getBrowserLanguage();
    var customResponse = {
        success: false,
        response: {
            results: content,
            message: "OK",
            exception: "",
        },
    };
    if (browserLang !== "en") {
        var body = {
            textTargetLanguageCode: target,
            translations: content,
        };
        try {
            let response = await axios.post(
                apiEndPointFromNode + "translate",
                body,
                {
                    headers: {
                        authorization: checkAndGetLocalStorageValue("accessToken"),
                        iscomingfromss: true,
                        customauth: generateJsonWebToken(),
                        withCredentials: true,                   
                       },
                }
            );
            return response.data;
        } catch (error) {
            return customResponse;
        }
    } else {
        return customResponse;
    }
};


export const getAndSetTranslateVal = async(arrayList, position, originalContent) =>{
  var currentVal = arrayList[position].text;
  if (currentVal === null){
      currentVal = originalContent;
  } 
  return currentVal ;
}

//5197 to generate JWT token
export const generateJsonWebToken = () => {
    return jwt.sign(
        { currentTime: getCurrentTime(), timeZone: timezone }, "secret", {
            expiresIn: 60 * 60,
        });
};

export const nodeEncryptedToken = (userUrlNode) => { 
  return jwt.sign({ data: userUrlNode }, "secret");
};

export const checkAndGetLocalStorageValue = (value) => {
  var localItem = localStorage.getItem(value);
  if (localItem === undefined || localItem === null || localItem === "null" || localItem === "undefined") {
    localItem = "";
    return localItem;
  } else {
    return localItem;
  }
};

export const checkAndGetSessionStorageValue = (value) => {
  var sessionValue = window.sessionStorage.getItem(value);
  if (sessionValue === undefined || sessionValue === null || sessionValue === "null" || sessionValue === "undefined") {
    sessionValue = "";
    return sessionValue;
  } else {
    return sessionValue;
  }
};

export const DateValidation = (state, selectedDate, isRequired,errorMsg) => {
  
  var dateformat = /^\d{4}\-(0[1-9]|1[012])\-(0[1-9]|[12][0-9]|3[01])$/;
  var dateError = "";
 
  if (
    selectedDate === undefined ||
    selectedDate === "" ||
    selectedDate.trim().length <= 0
  ) 
  {
    if(isRequired){
      return errorMsg;
    }else{
      return "";
    }
    
  } else if (!dateformat.test(selectedDate)) {
    dateError="";
      dateError = (
      <Trans i18nKey="userregistration.validation.date_msg1">
        Please enter valid date
      </Trans>
    );
    return dateError
    
  }
};

export const getDateWithIso = (date, numberToAdd) => {
    //Year: for min date, set -1 and for max date, set +1
    //Day: for min date, set +1 and for max date, set -1
    date.setFullYear(date.getFullYear() + numberToAdd, date.getMonth(), date.getDate() - numberToAdd);
    return date.toISOString().slice(0, 10);
  }

  export const getDate= (date, numberToAdd) => {
    //Year: for min date, set -1 and for max date, set +1
    //Day: for min date, set +1 and for max date, set -1
    date.setFullYear(date.getFullYear() + numberToAdd, date.getMonth(), date.getDate() - numberToAdd);    
    return date
  }

  export const getFormattedDate = (date, addYears, addMonths, addDays) => {
    date.setFullYear(date.getFullYear() + addYears , date.getMonth() + addMonths , date.getDate() + addDays);
    return date.toISOString();
  }
  export const getDefaultDate = () => {
    return new Date("0001","00","01").toISOString();
  }
  
export const check = (input) => {  
      if(input.currentTarget.validity.rangeUnderflow){ 
       input.currentTarget.setCustomValidity(
      i18next.t("findcareoption.Start.travelDateErrormsg1")+ input.currentTarget.value +
      i18next.t("findcareoption.Start.travelDateErrormsg2")
                            );    
      }
    else if(input.currentTarget.validity.rangeOverflow) {
       input.currentTarget.setCustomValidity(i18next.t("findcareoption.Start.travelDateErrormsg1") + input.currentTarget.value +i18next.t("findcareoption.Start.travelDateErrormsg3"));  
    }
      else {  
          input.currentTarget.setCustomValidity("");
      }                 
  }

export const checkUrlSearchParamsHas = (urlQuery) => {
    const params = new URLSearchParams(urlQuery);

    // Create the new one with lowercase
    const newParams = new URLSearchParams();
    for (const [name, value] of params) {
        newParams.append(name.toLowerCase(), value);
    }
  
    return new URLSearchParams(newParams).has("organizationid");
};

export const getUrlSearchParamsValue = (urlQuery) => {
    const params = new URLSearchParams(urlQuery);

    // Create the new one with lowercase
    const newParams = new URLSearchParams();
    for (const [name, value] of params) {
        newParams.append(name.toLowerCase(), value);
    }

    var hasValue = new URLSearchParams(newParams).has("organizationid");
    if (hasValue) {
        return new URLSearchParams(newParams).get("organizationid");
    } else {
        return "";
    }
};

export const gtag = (...args) => {
  if (typeof window !== "undefined") {
    if (typeof window.gtag === "undefined") {
      window.dataLayer = window.dataLayer || [];
      window.gtag = function gtag() {
        window.dataLayer.push(arguments);
      };
    }

    window.gtag(...args);
  }
};

